"use client";

import type { FC } from "react";
import { Flex, useThemeSlot } from "@huub-web/ui";

import { DefaultPageHeading } from "../../components/DefaultPageHeading/DefaultPageHeading";

export type MaximumMortgageHeadingTemplateProps = Record<string, never>;

export const MaximumMortgageHeadingTemplate: FC<
  MaximumMortgageHeadingTemplateProps
> = ({ ref }) => {
  const PageHeading = useThemeSlot({
    key: "pageHeading",
    defaultComponent: DefaultPageHeading,
  });

  return (
    <Flex ref={ref} direction="column" gap="s">
      <PageHeading scope="maximumMortgage" />
    </Flex>
  );
};
